import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, FormFieldContainer, TextField, Label } from 'cw-ui-core';
import React, { useEffect } from 'react';
import Locale from 'src/i18n';
import layoutCss from 'src/styles/layout.scss';
import ConditionsListContainer from '../../../../components/ConditionsList/ConditionsListContainer';
import css from './EditProductInstanceDialog.scss';
import MultiCheckBoxContainer from '../../../../components/MultiCheckBox/MultiCheckBoxContainer';
import TextBoxListContainer from '../../../../components/TextBoxList/TextBoxListContainer';
import TextButton from '../../../../components/TextButton';

export const EDIT_PRODUCT_INSTANCE_DIALOG = 'EDIT_PRODUCT_INSTANCE_DIALOG';

const EditProductInstanceDialog = props => {
    const { onDidMount, onUriChange, onUriFieldFocusChange, users, onOk, disabledSave, onCancel } = props;
    const { formatMessage } = props.intl;
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const getFullName = item => `${item.firstName} ${item.lastName}`;

    const dialogButtons = [
        <TextButton
            key="ok"
            automationName="ok"
            text={formatMessage(Locale.save)}
            onClick={onOk}
            disabled={disabledSave}
        />,
        <TextButton key="cancel" automationName="cancel" text={formatMessage(Locale.cancel)} onClick={onCancel} />,
    ];

    return (
        <Dialog
            dialogId={EDIT_PRODUCT_INSTANCE_DIALOG}
            header={formatMessage(Locale.editProductInstance)}
            buttons={dialogButtons}>
            <br />
            <div className={css.wrap}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={EDIT_PRODUCT_INSTANCE_DIALOG} />
                <div className={layoutCss.podRow}>
                    <div className={layoutCss.podCol} style={{ flexGrow: 2 }}>
                        <FormFieldContainer
                            path={['instanceDetails', 'instance']}
                            label={formatMessage(Locale.instance)}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}>
                            <TextField disabled />
                        </FormFieldContainer>
                        <FormFieldContainer
                            path={['instanceDetails', 'clientId']}
                            label={formatMessage(Locale.clientId)}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}>
                            <TextField disabled />
                        </FormFieldContainer>
                        <FormFieldContainer
                            path={['instanceDetails', 'clientName']}
                            label={formatMessage(Locale.displayName)}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}>
                            <TextField />
                        </FormFieldContainer>
                        <FormFieldContainer
                            path={['instanceDetails', 'backChannelLogoutUri']}
                            label={formatMessage(Locale.backChannelLogoutUri)}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}>
                            <TextField />
                        </FormFieldContainer>
                        <FormFieldContainer
                            path={['instanceDetails', 'frontChannelLogoutUri']}
                            label={formatMessage(Locale.frontChannelLogoutUri)}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}>
                            <TextField />
                        </FormFieldContainer>
                        <Label value={formatMessage(Locale.redirectUris)} className={css.formLabel} />
                        <Label
                            value={formatMessage(Locale.redirectUriRequirements)}
                            className={css.redirectUriRequirements}
                        />
                        <ConditionsListContainer path={['uriValidation']} screenKey={EDIT_PRODUCT_INSTANCE_DIALOG} />
                        <TextBoxListContainer
                            buttonText={formatMessage(Locale.addUri)}
                            path={['instanceDetails', 'redirectUris']}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}
                            onChange={onUriChange}
                            onFocusChange={onUriFieldFocusChange}
                        />
                    </div>
                    <div className={layoutCss.podCol} style={{ flexGrow: 2 }}>
                        <FormFieldContainer
                            path={['checkboxes', 'selectedUsers']}
                            label={formatMessage(Locale.users)}
                            screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}>
                            <MultiCheckBoxContainer
                                pathKey={['checkboxes', 'selectedUsers']}
                                screenKey={EDIT_PRODUCT_INSTANCE_DIALOG}
                                items={users}
                                style={{ height: '63vh' }}
                                customName={getFullName}
                            />
                        </FormFieldContainer>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(EditProductInstanceDialog);
